import { MetaFunction } from "@remix-run/node";
import NavbarPrivacyPolicy from "~/components/NavbarPrivacyPolicy";
import Content from "~/components/Content";
import { LargeText } from "~/components/Text";
import Footer from "~/components/Footer";

export const meta: MetaFunction = () => {
  return [{ title: `Integritetspolicy - Linkt` }];
};

export default function PrivacyPolicy() {
  return (
    <div className="">
      <NavbarPrivacyPolicy />
      <main className="[&_p]:text-muted-foreground [&_p]:mb-4 [&_h2]:mt-8 [&_h2]:mb-5 [&_h2]:font-normal [&_h3]:text-muted-foreground [&_h3]:uppercase ">
        <Content className="py-12 lg:py-24" variant="narrow">
          <h1 className="mb-12">
            <LargeText>Integritetspolicy för linkt.se</LargeText>
          </h1>
          <p>
            Denna integritetspolicy förklarar insamlingen och behandlingen av
            dina uppgifter.
          </p>
          <h2>INFORMATION SOM SAMLAS IN</h2>
          <h3>Namn & organisation</h3>
          <p>
            Vi samlar in det namn och organisationsnamn som anges vid
            kontaktformuläret i syfte att kunna göra personliga mejlutskick.
          </p>
          <h3>E-postadress</h3>
          <p>
            Vi samlar in e-postadressen som anges vid kontaktformuläret i syfte
            att kunna besvara inkommande förfrågningar.
          </p>
          <h2>Lagring av data</h2>
          <p>
            Alla data lagras säkert inom Europeiska unionen (EU), vilket
            säkerställer överensstämmelse med den allmänna
            dataskyddsförordningen (GDPR).
          </p>
          <h2>Ingen inblandning av tredje part</h2>
          <p>
            Vi vill försäkra dig om att dina uppgifter inte delas, säljs eller
            på annat sätt utlämnas till tredje part.
          </p>
          <h2>ANVÄNDNING AV COOKIES</h2>
          <h3>Vad är en cookie?</h3>
          <p>
            Vi använder "cookies" på linkt.se. En cookie är en bit information
            som skickas av en webbserver till din webbläsare, vilket möjliggör
            att servern samlar in information från webbläsaren.
          </p>
          <h3>Vilka cookies använder vi?</h3>
          <p>
            Vi använder en cookie för att spara ditt val av temaläge (mörkt
            eller ljust). Detta ger en förbättrad användarupplevelse då
            temaläget sparas vid återbesök på webbplatsen.
          </p>
          <p>
            Genom att använda linkt.se samtycker du till användningen av cookies
            enligt beskrivningen i denna integritetspolicy. Läs mer om
            användningen av cookies på{" "}
            <a
              className="text-blue-500"
              href="http://www.cookiecentral.com."
              target="_blank"
              rel="noreferrer nofollow"
            >
              www.cookiecentral.com
            </a>
            .
          </p>
          <h2>ÄNDRINGAR I DENNA INTEGRITETSPOLICY</h2>
          <p>
            Vi förbehåller oss rätten att uppdatera och ändra denna
            integritetspolicy för att reflektera förändringar i våra metoder
            eller lagliga krav. Eventuella uppdateringar publiceras på denna
            sida.
          </p>
          <h2>KONTAKT</h2>
          <p>
            Om du har några förfrågningar angående din personliga information
            eller några frågor om vår uppgiftsbehandling, kontakta oss på
            info@linkt.se.
          </p>
        </Content>
      </main>
      <Footer />
    </div>
  );
}
